import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { mapSearchResults } from "../adapter";
import search from "../search";
import { CategoryListItemType } from "../types";
import TabTable from "./tabTable";
import { displayedColumns } from "../constants";

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
	tab: CategoryListItemType;
	resetFilters: boolean;
	setResetFilters: React.Dispatch<React.SetStateAction<boolean>>;
	setCanResetFilters: React.Dispatch<React.SetStateAction<boolean>>;
}

const TabPanel = ({
	children,
	value,
	index,
	tab,
	resetFilters,
	setResetFilters,
	setCanResetFilters,
}: TabPanelProps) => {
	const theme = useTheme();
	const selectedCategory = tab.label;
	const [results, setResults] = useState<{
		headers: string[];
		rows: React.JSX.Element[][];
	}>({ headers: [], rows: [] });
	const [loading, setLoading] = useState(false);
	const [selectedFilters, setSelectedFilters] = useState<{
		[k in string]: string;
	}>({});
	const handleFilterChange = (filter: string, value: string) => {
		if (value === "") {
			const { [filter]: _, ...rest } = selectedFilters;
			setSelectedFilters(rest);
			if (Object.keys(rest).length === 0) setCanResetFilters(false);
			else setCanResetFilters(true);
			return;
		}
		setSelectedFilters({ ...selectedFilters, [filter]: value });
		setCanResetFilters(true);
	};
	useEffect(() => {
		if (resetFilters) {
			setSelectedFilters({});
			setResetFilters(false);
			setCanResetFilters(false);
		}
	}, [resetFilters, setResetFilters]);
	const showSearchResults = async () => {
		if (value !== index) return;
		setLoading(true);
		const searchResults = await search(
			selectedCategory,
			Object.keys(selectedFilters).map(
				(key) =>
					`${key.split(" ").join("_").toLowerCase()}='${
						selectedFilters[key]
					}'`
			)
		);
		if (searchResults) {
			const mappedResults = mapSearchResults(
				selectedCategory,
				searchResults
			);
			if (mappedResults) setResults(mappedResults);
		}
		setLoading(false);
	};
/*
	const getFilters = async () => {
		const filters = await window.fetch( `/wp-json/product-finder/filters` ).then( response => response.json() );
		if ( filters[ tab.label ] ) {
			filters[ tab.label ].forEach( ( filter: any ) => {
const itemIndex = tab.filters.findIndex( ( item ) => {
	return item.label === filter.name;
} );
console.log({ filter, itemIndex });
			} );
		}

console.log( {
	filters,
	tab,
} );
	};
*/
	useEffect(() => {
		showSearchResults();
	}, [selectedFilters]);
	useEffect(() => {
		setResults({ headers: displayedColumns[selectedCategory], rows: [] });
		setSelectedFilters({});
		setCanResetFilters(false);
//		getFilters();
	}, [value]);

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`tabpanel-${index}`}
			aria-labelledby={`tab-${index}`}
		>
			{value === index && (
				<div className="flex flex-wrap py-5 gap-[10px]">
					{tab.filters.map((filter, index) => (
						<FormControl sx={{ minWidth: 200 }} key={index}>
							<InputLabel
								id={`select-${filter.label
									.toLowerCase()
									.replace(/ /g, "-")}-label`}
								size="small"
								sx={{
									fontSize: "12px",
									lineHeight: "14px",
									transform: "translate(10px, 11px) scale(1)",
									"&.MuiInputLabel-shrink": {
										transform:
											"translate(14px, -5px) scale(0.75)",
									},
								}}
							>
								{filter.label}
							</InputLabel>
							<Select
								labelId={`select-${filter.label
									.toLowerCase()
									.replace(/ /g, "-")}-label`}
								id={`select-${filter.label
									.toLowerCase()
									.replace(/ /g, "-")}`}
								name={`select-${filter.label
									.toLowerCase()
									.replace(/ /g, "-")}`}
								color="secondary"
								sx={{
									background: theme.palette.secondary.light,
									borderRadius: "6px",
								}}
								SelectDisplayProps={{
									style: {
										padding: "10px 11px",
										paddingRight: "30px",
										fontSize: "12px",
										lineHeight: "14px",
										minHeight: "0",
									},
								}}
								value={selectedFilters[filter.label] || ""}
								onChange={(e) => {
									if (!e.target.value) {
										handleFilterChange(filter.label, "");
										setTimeout(() => {
											document
												?.getElementById(e.target.name)
												?.blur();
										}, 100);
										return;
									}
									handleFilterChange(
										filter.label,
										e.target.value as string
									);
								}}
								MenuProps={{
									sx: {
										"& .MuiPopover-paper": {
											background:
												theme.palette.secondary.light,
										},
									},
								}}
								label={filter.label}
							>
								<MenuItem
									value=""
									sx={{
										fontSize: "12px",
										lineHeight: "14px",
									}}
								>
									All
								</MenuItem>
								{filter.options.map((option, index) => (
									<MenuItem
										key={index}
										value={option.value}
										sx={{
											fontSize: "12px",
											lineHeight: "14px",
										}}
									>
										{option.label}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					))}
				</div>
			)}
			<TabTable tableData={results} loading={loading} />
		</div>
	);
};

export default TabPanel;
